/**
 * Copyright © Veeam Software Group GmbH.
 */

import { SobrUsageType } from '@veeam-vspc/models/web-controllers';

import type { RequestErrorResponse, RequestSuccessResponse } from '@veeam-vspc/shared/interfaces';
import type { TransportService } from '@veeam-vspc/shared/core';
import type { VspcLang } from 'configs/languages';

import { transformBaseChartData } from 'views/pages/TrendsPage/helpers';

import type { ChartDataWithCategories } from 'views/components/HighchartsWrapper/interfaces';
import type { TrendData } from 'views/pages/TrendsPage/interfaces';

const names = [
    { label: 'Performance Tier', type: SobrUsageType.PerfTier },
    { label: 'Capacity Tier', type: SobrUsageType.CapacityTier },
    { label: 'Archive Tier', type: SobrUsageType.ArchiveTier },
    { label: 'Object Storage', type: SobrUsageType.ObjectStorage },
    { label: 'Regular Storage', type: SobrUsageType.RegularStorage },
];

export class SobrUsageService {

    constructor(
        private transportService: TransportService<RequestErrorResponse | Error>,
        private langService: VspcLang,
    ) {}

    fetchData({ formatDimension = true, reportingPeriodInfo }): Promise<ChartDataWithCategories> {
        return this.transportService
            .request('/Trends/CloudSobrUsage', { ...reportingPeriodInfo })
            .then((resp: RequestSuccessResponse<TrendData>) =>
                transformBaseChartData(this.langService, resp.data.trends, reportingPeriodInfo, names, formatDimension));
    }
}
